module.exports = __webpack_public_path__ + "static/media/copy_normal.c0182112.svg";